const initialState = {}

const users = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_CONTENT':
            return { ...state, ...action.content }
        default:
            return { ...state }
    }
}
export default users